import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/images/logo/MobilityLogo_Grn.png'


const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "isolate" }
const _hoisted_3 = { class: "relative pt-14" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]",
    style: {"clip-path":"polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"}
  })
], -1)
const _hoisted_5 = { class: "py-24 sm:py-32" }
const _hoisted_6 = { class: "mx-auto max-w-7xl px-6 lg:px-8" }
const _hoisted_7 = { class: "mx-auto max-w-2xl text-center" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "mt-10 flex items-center justify-center gap-x-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", { class: "h-12 cursor-pointer rounded-md bg-green-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" }, [
  /*#__PURE__*/_createTextVNode("Login "),
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]",
    style: {"clip-path":"polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"}
  })
], -1)
const _hoisted_13 = { class: "mx-auto mt-32 max-w-7xl px-6 sm:mt-56 lg:px-8" }
const _hoisted_14 = { class: "mx-auto max-w-2xl lg:text-center" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl" }
const _hoisted_18 = { class: "grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16" }
const _hoisted_19 = { class: "text-base font-semibold leading-7 text-gray-900" }
const _hoisted_20 = { class: "absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-green-600" }
const _hoisted_21 = { class: "mt-2 text-base leading-7 text-gray-600" }
const _hoisted_22 = { class: "mx-auto mt-32 max-w-7xl sm:mt-56 sm:px-6 lg:px-8" }
const _hoisted_23 = { class: "relative overflow-hidden bg-gray-900 px-6 py-20 shadow-xl sm:rounded-3xl sm:px-10 sm:py-24 md:px-12 lg:px-20" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  class: "absolute inset-0 h-full w-full object-cover brightness-150 saturate-0",
  src: "https://images.unsplash.com/photo-1601381718415-a05fb0a261f3?ixid=MXwxMjA3fDB8MHxwcm9maWxlLXBhZ2V8ODl8fHxlbnwwfHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1216&q=80",
  alt: ""
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-gray-900/90 mix-blend-multiply" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute -left-80 -top-56 transform-gpu blur-3xl",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "aspect-[1097/845] w-[68.5625rem] bg-gradient-to-r from-[#ff4694] to-[#776fff] opacity-[0.45]",
    style: {"clip-path":"polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"}
  })
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  class: "hidden md:absolute md:bottom-16 md:left-[50rem] md:block md:transform-gpu md:blur-3xl",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "aspect-[1097/845] w-[68.5625rem] bg-gradient-to-r from-[#ff4694] to-[#776fff] opacity-25",
    style: {"clip-path":"polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"}
  })
], -1)
const _hoisted_28 = { class: "relative mx-auto max-w-2xl lg:mx-0" }
const _hoisted_29 = { class: "mt-6 text-lg font-semibold text-white sm:text-xl sm:leading-8" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "mx-auto mt-32 max-w-7xl px-6 sm:mt-56 lg:px-8" }
const _hoisted_32 = { class: "mx-auto max-w-4xl divide-y divide-gray-900/10" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold leading-10 tracking-tight text-gray-900" }, "FAQ", -1)
const _hoisted_34 = { class: "mt-10 space-y-6 divide-y divide-gray-900/10" }
const _hoisted_35 = { class: "text-base font-semibold leading-7" }
const _hoisted_36 = { class: "ml-6 flex h-7 items-center" }
const _hoisted_37 = { class: "text-base leading-7 text-gray-600" }
const _hoisted_38 = { class: "relative -z-10 mt-32 px-6 lg:px-8" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute inset-x-0 top-1/2 -z-10 flex -translate-y-1/2 transform-gpu justify-center overflow-hidden blur-3xl sm:bottom-0 sm:right-[calc(50%-6rem)] sm:top-auto sm:translate-y-0 sm:transform-gpu sm:justify-end",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "aspect-[1108/632] w-[69.25rem] flex-none bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-25",
    style: {"clip-path":"polygon(73.6% 48.6%, 91.7% 88.5%, 100% 53.9%, 97.4% 18.1%, 92.5% 15.4%, 75.7% 36.3%, 55.3% 52.8%, 46.5% 50.9%, 45% 37.4%, 50.3% 13.1%, 21.3% 36.2%, 0.1% 0.1%, 5.4% 49.1%, 21.4% 36.4%, 58.9% 100%, 73.6% 48.6%)"}
  })
], -1)
const _hoisted_40 = { class: "mx-auto max-w-2xl text-center" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl" }, "Auf gehts!", -1)
const _hoisted_42 = { class: "mt-10 flex items-center justify-center gap-x-6" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("a", { class: "h-12 cursor-pointer rounded-md bg-green-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" }, " Login", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute left-1/2 right-0 top-full -z-10 hidden -translate-y-1/2 transform-gpu overflow-hidden blur-3xl sm:block",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30",
    style: {"clip-path":"polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"}
  })
], -1)
const _hoisted_45 = { class: "mx-auto mt-32 max-w-7xl px-6 lg:px-8" }
const _hoisted_46 = {
  "aria-labelledby": "footer-heading",
  class: "relative border-t border-gray-900/10 py-24 sm:mt-56 sm:py-32"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h2", {
  id: "footer-heading",
  class: "sr-only"
}, "Footer", -1)
const _hoisted_48 = { class: "xl:grid xl:grid-cols-3 xl:gap-8" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-7",
  src: _imports_0,
  alt: "MobiPoints"
}, null, -1)
const _hoisted_50 = { class: "mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0" }
const _hoisted_51 = { class: "md:grid md:grid-cols-2 md:gap-8" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-semibold leading-6 text-gray-900" }, "Solutions", -1)
const _hoisted_53 = {
  role: "list",
  class: "mt-6 space-y-4"
}
const _hoisted_54 = ["href"]
const _hoisted_55 = { class: "mt-10 md:mt-0" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-semibold leading-6 text-gray-900" }, "Support", -1)
const _hoisted_57 = {
  role: "list",
  class: "mt-6 space-y-4"
}
const _hoisted_58 = ["href"]
const _hoisted_59 = { class: "md:grid md:grid-cols-2 md:gap-8" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-semibold leading-6 text-gray-900" }, "Company", -1)
const _hoisted_61 = {
  role: "list",
  class: "mt-6 space-y-4"
}
const _hoisted_62 = ["href"]
const _hoisted_63 = { class: "mt-10 md:mt-0" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-semibold leading-6 text-gray-900" }, "Legal", -1)
const _hoisted_65 = {
  role: "list",
  class: "mt-6 space-y-4"
}
const _hoisted_66 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_DisclosureButton = _resolveComponent("DisclosureButton")!
  const _component_DisclosurePanel = _resolveComponent("DisclosurePanel")!
  const _component_Disclosure = _resolveComponent("Disclosure")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { class: "ion-no-padding" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h1", {
                        class: "text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl",
                        innerHTML: $setup.titleText
                      }, null, 8, _hoisted_8),
                      _createElementVNode("p", {
                        class: "mt-6 text-lg leading-8 text-gray-600",
                        innerHTML: $setup.descriptionText
                      }, null, 8, _hoisted_9),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_router_link, { to: "/login" }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _hoisted_12
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("h2", {
                    class: "text-base font-semibold leading-7 text-indigo-600",
                    innerHTML: $setup.featureTitle
                  }, null, 8, _hoisted_15),
                  _createElementVNode("p", {
                    class: "mt-6 text-lg leading-8 text-gray-600",
                    innerHTML: $setup.featureDescription
                  }, null, 8, _hoisted_16)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("dl", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.features, (feature) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: feature.name,
                        class: "relative pl-16"
                      }, [
                        _createElementVNode("dt", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(feature.icon), {
                              class: "h-6 w-6 text-white",
                              "aria-hidden": "true"
                            }))
                          ]),
                          _createTextVNode(" " + _toDisplayString(feature.name), 1)
                        ]),
                        _createElementVNode("dd", _hoisted_21, _toDisplayString(feature.description), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _hoisted_25,
                  _hoisted_26,
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("blockquote", _hoisted_29, [
                      _createElementVNode("p", null, "“" + _toDisplayString($setup.quoteTitle) + "”", 1),
                      _createElementVNode("div", {
                        class: "font-semibold text-center mt-2",
                        innerHTML: $setup.quoteAuthor
                      }, null, 8, _hoisted_30)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("dl", _hoisted_34, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.faqs, (faq) => {
                      return (_openBlock(), _createBlock(_component_Disclosure, {
                        as: "div",
                        key: faq.question,
                        class: "pt-6"
                      }, {
                        default: _withCtx(({ open }) => [
                          _createElementVNode("dt", null, [
                            _createVNode(_component_DisclosureButton, { class: "flex w-full items-start justify-between text-left text-gray-900" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_35, _toDisplayString(faq.question), 1),
                                _createElementVNode("span", _hoisted_36, [
                                  (!open)
                                    ? (_openBlock(), _createBlock(_component_ion_icon, {
                                        key: 0,
                                        size: "large",
                                        icon: $setup.icons.addOutline,
                                        "aria-hidden": "true"
                                      }, null, 8, ["icon"]))
                                    : (_openBlock(), _createBlock(_component_ion_icon, {
                                        key: 1,
                                        size: "large",
                                        icon: $setup.icons.removeOutline,
                                        "aria-hidden": "true"
                                      }, null, 8, ["icon"]))
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createVNode(_component_DisclosurePanel, {
                            as: "dd",
                            class: "mt-2 pr-12"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_37, _toDisplayString(faq.answer), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_router_link, { to: "/login" }, {
                      default: _withCtx(() => [
                        _hoisted_43
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _hoisted_44
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("footer", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", null, [
                        _hoisted_52,
                        _createElementVNode("ul", _hoisted_53, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.footerNavigation.solutions, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: item.name
                            }, [
                              _createElementVNode("a", {
                                href: item.href,
                                class: "text-sm leading-6 text-gray-600 hover:text-gray-900"
                              }, _toDisplayString(item.name), 9, _hoisted_54)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _hoisted_56,
                        _createElementVNode("ul", _hoisted_57, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.footerNavigation.support, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: item.name
                            }, [
                              _createElementVNode("a", {
                                href: item.href,
                                class: "text-sm leading-6 text-gray-600 hover:text-gray-900"
                              }, _toDisplayString(item.name), 9, _hoisted_58)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", null, [
                        _hoisted_60,
                        _createElementVNode("ul", _hoisted_61, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.footerNavigation.company, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: item.name
                            }, [
                              _createElementVNode("a", {
                                href: item.href,
                                class: "text-sm leading-6 text-gray-600 hover:text-gray-900"
                              }, _toDisplayString(item.name), 9, _hoisted_62)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _hoisted_64,
                        _createElementVNode("ul", _hoisted_65, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.footerNavigation.legal, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: item.name
                            }, [
                              _createElementVNode("a", {
                                href: item.href,
                                class: "text-sm leading-6 text-gray-600 hover:text-gray-900"
                              }, _toDisplayString(item.name), 9, _hoisted_66)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}